import type { InboxView } from "../../../types";
import type { Location } from "react-router-dom";

export const getInboxView = (location: Location): InboxView => {
  const pathname = location.pathname;
  const segments = pathname.split("/");
  const index = segments.findIndex((segment) => segment === "messaging");
  if (index === -1) return "inbox";
  return (segments[index + 1] ?? "inbox") as InboxView;
};
